import React, { useState } from "react";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";
import { useEventos } from "../../context/EventosContext";
import Sidebar from "../../components/sidebar/Sidebar";
import Header from "../../components/eventos/header/Header";
import Midia from "../../components/eventos/midia/Midia";
import DetalhesEvento from "../../components/eventos/detalhesEvento/DetalhesEvento";
import ActionFooter from "../../components/actionFooter/ActionFooter";
import { DashboardLayout, MainContent } from "../dash/styles";
import { Container } from "./styles";
import dayjs from "dayjs";

export default function CriarEvento() {
  const navigate = useNavigate();
  const { setEventos } = useEventos();

  const [eventoData, setEventoData] = useState({
    titulo: "",
    descricao: "",
    organizador: "",
    vagas: "0",
    data: null,
    hora: null,
    local: "",
    tags: [],
    imagem: null,
    preview: "",
    acesso: "Público",
    status: "Upcoming",
    contatos: [{ telefone: "", email: "", redeSocial: "" }],
    conteudos: [{ titulo: "", itens: [""] }],
    destacado: false,
    xp: 0,
  });

  const handleSave = async () => {
    if (!eventoData.titulo || !eventoData.data) {
      alert("Por favor, preencha pelo menos o título e a data.");
      return;
    }

    const formData = new FormData();

    // ---------------- CAMPOS PRINCIPAIS ----------------
    formData.append("titulo", eventoData.titulo);
    formData.append("descricao", eventoData.descricao);
    formData.append("organizador", eventoData.organizador);
    formData.append(
      "data",
      dayjs(eventoData.data).toISOString()
    );

    if (eventoData.hora) {
      formData.append(
        "hora",
        dayjs(eventoData.hora).format("HH:mm")
      );
    }
    formData.append("local", eventoData.local);
    formData.append("status", eventoData.status);
    formData.append("xp", String(eventoData.xp || 0));

    // 🔥 CAMPO REAL DO BANCO
    formData.append("acesso", eventoData.acesso);

    if (eventoData.acesso === "Privado") {
      formData.append("vagas", String(eventoData.vagas || 0));
    } else {
      formData.append("vagas", "0"); // limpa quando volta para público
    }

    // ---------------- ARRAYS ----------------
    formData.append("tags", JSON.stringify(eventoData.tags));
    formData.append("contatos", JSON.stringify(eventoData.contatos));
    formData.append("conteudos", JSON.stringify(eventoData.conteudos));

    // ---------------- OUTROS ----------------
    formData.append("destacado", String(eventoData.destacado));

    if (eventoData.imagem instanceof File) {
      formData.append("imagem", eventoData.imagem);
    }

    try {
      console.log("Enviando dados do evento:", formData);
      const response = await api.post(
        "/api/content/eventos",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setEventos((prev) =>
        Array.isArray(prev)
          ? [...prev, response.data]
          : [response.data]
      );

      alert("Evento criado com sucesso!");
      navigate("/eventos");
    } catch (error) {
      console.error("Erro ao salvar evento:", error);
      alert("Erro ao criar evento. Verifique o backend.");
    }
  };

  return (
    <DashboardLayout>
      <Sidebar />

      <Container>
        <Header
          title="Criar novo evento"
          description="Adicione um novo evento ao calendário da sua comunidade"
          breadcrumbMain="Eventos"
          breadcrumbCurrent="Criar evento"
        />

        <MainContent>
          <Midia
            initialPreview={eventoData.preview}
            onFileSelect={(file, preview) =>
              setEventoData({
                ...eventoData,
                imagem: file,
                preview: preview,
              })
            }
          />

          <DetalhesEvento
            eventoData={eventoData}
            setEventoData={setEventoData}
          />

          <ActionFooter onSave={handleSave} />
        </MainContent>
      </Container>
    </DashboardLayout>
  );
}
